// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__122jy","left":"styles_left__1RIo7","desktopActions":"styles_desktopActions__5BfDk","title":"styles_title__1XxoF"};